<template>
	<div class="page">
		<!-- 专题专栏详情 -->
		<!-- type8 -->
		<div class="p-r" v-for="(item, index) in type8" :key="index">
			<!-- <img class="p-a hover-pointer" @click="$router.push('/index')" src="@/assets/img/index/ztzl/logo.png" alt="" style="left: 15px; top: 15px;"> -->
			<img class="p-a hover-pointer" @click="handleBigImg(item)" src="@/assets/img/index/ztzl/logo.png" alt="" style="left: 30px; top: 30px;">
			<img :src="item.back_img" alt="" style="width: 100%" />
		</div>
		<!-- <img class="hover-pointer" @click="handleBigImg(item)" v-for="(item, index) in type8" :key="index" :src="item.back_img" alt="" style="width: 100%" /> -->

		<div class="con">
			<!-- type1  标题详情（参考乡村振兴） -->
			<div v-for="(item, index) in type1" :key="'type1_' + index" class="type1 hover-pointer jy p-r margin-tb"
				@click="openPage(item)">
				<!-- <img class="p-a" src="@/assets/img/index/ztzl/jy.png" alt=""> -->
				<span class="p-a text-white ellipse padding-lr text-26">{{
          item.list_title
        }}</span>
				<p class="text-20 text-333">{{ item.list_info }}</p>
			</div>

			<!-- type2  标题、详情、图片（交通领域专项整治专题） -->
			<div class="type2 hover-pointer" v-for="(item, index) in type2" :key="'type2_' + index" @click="openPage(item)">
				<h1 class="tc padding-tb-lg blue-color" style="font-size: 35px">
					{{ item.list_title }}
				</h1>
				<p class="text-20">{{ item.list_info }}</p>

				<img class="margin-tb" :src="item.back_img" alt="" style="max-width: 800px;margin: 30px auto;display: block;" />
			</div>

			<!-- type3 最新政策列表（参考交通领域专项整治专题） -->
			<div class="type3" v-if="type3.length > 0">
				<img src="@/assets/img/index/ztzl/xxzt.png" alt="" style="width: 100%" />

				<div class="list padding-top padding-bottom-xl">
					<dl class="flex padding-bottom hover-pointer" v-for="(item, index) in type3" :key="'type3_' + index"
						@click="openPage(item)">
						<dt style="    width: 410px;height: 220px;">
							<img :src="item.back_img" alt="" style="width:100%;height:100%;" />
						</dt>
						<dd class="padding-left-sm">
							<h2 class="text-22 padding-tb-sm">{{ item.list_title }}</h2>
							<p class="text-20 text-666 ellipse2">{{ item.list_info }}</p>
							<p class="tr text-18 text-999">{{ item.create_time }}</p>
						</dd>
					</dl>

					<!-- <a href="" class="text-16 c481-color fr">更多>></a> -->
				</div>
			</div>

			<!-- type5 轮播图（参考乡村振兴）-->
			<div class="type5 margin-bottom" v-if="type5.length > 0">
				<el-carousel class="carouselBox" arrow="never" :autoplay="true" :interval="4000">
					<el-carousel-item class="hover-pointer" v-for="(item, index) in type5" :key="'type5_' + index">
						<div class="swiperBox flex" @click="openPage(item)">
							<img :src="item.back_img" alt="" />
							<div class="swiperTxt padding-lg">
								<h3 class="text-22 text-333 margin-bottom">
									{{ item.list_title }}
								</h3>
								<p class="text-18 text-666">{{ item.list_info }}</p>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
			</div>

			<!-- type4 最新消息  黄色（参考乡村振兴）   -->
			<div class="type4" v-if="type4.length > 0">
				<img class="margin-tb-lg" src="@/assets/img/index/ztzl/zxxx.png" alt="" style="width: 100%" />

				<ul class="ul clearfix">
					<li class="ellipse text-20 padding-right hover-pointer" v-for="(item, index) in type4"
						:key="item.deta_id" @click="openPage(item)">
						<span class="margin-lr-xs"></span>{{ item.list_title }}
					</li>
				</ul>
				<div class="tr padding-bottom">
					<!-- <a href="" class="text-16 text-999">更多>></a> -->
				</div>
			</div>

			<!-- type6 最新消息蓝色 （优化法治化运营环境 -->
			<div class="type6" v-if="type6.length > 0">
				<div class="imgBox p-r margin-bottom-sm">
					<img src="@/assets/img/index/ztzl/zxxx1.png" alt="" />
					<!-- <span class="p-a text-16 text-999 hover-pointer">更多>></span> -->
				</div>

				<ul class="ul clearfix">
					<li class="ellipse text-20 padding-right hover-pointer" v-for="(item, index) in type6"
						:key="item.deta_id" @click="openPage(item)">
						<span class="margin-lr-xs"></span>{{ item.list_title }}
					</li>
				</ul>
			</div>

			<!-- type7 重点消息（优化法治化运营环境  -->
			<div class="type7" v-if="type7.length > 0">
				<div class="imgBox p-r margin-bottom">
					<img src="@/assets/img/index/ztzl/zdxx.png" alt="" />
					<!-- <span class="p-a text-16 text-999 hover-pointer">更多>></span> -->
				</div>

				<div class="list padding-bottom">
					<div class="item padding-bottom-sm hover-pointer" v-for="(item, index) in type7"
						:key="'type7_' + index" @click="openPage(item)">
						<h3 class="text-22 ellipse margin-tb-xs p-r padding-left-sm">
							{{ item.list_title }}
						</h3>
						<p class="text-20 text-666">
							{{ item.list_info }}
							<span class="fr text-999 text-18">{{ item.time }}</span>
						</p>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>
<script>
	import Footer from "@/components/footer/footer.vue";
	import {
		ztzlDetails
	} from "@/apis/index";
	export default {
		components: {
			Footer,
		},
		data() {
			return {
				bigImg: "",
				id: null,
				hsZxxx: [{
						tit: "国家乡村振兴局赴红色教育基地参观学习国家乡村振兴局赴红色教育基地参观学习",
						id: 1,
					},
					{
						tit: "国家乡村振兴局召开学习贯彻习近平新时代中国特色近平新时代中国特色社...",
						id: 2,
					},
					{
						tit: "农业农村部（国家乡村振兴局）与西藏自治区政府召开...",
						id: 3
					},
					{
						tit: "贵南：党建助力村集体经济发展壮大",
						id: 4
					},
					{
						tit: "中共中央 国务院关于实施乡村振兴战略的意见",
						id: 5
					},
					{
						tit: "贵南：党建助力村集体经济发展壮大",
						id: 6
					},
					{
						tit: "中共中央 国务院关于实施乡村振兴战略的意见",
						id: 7
					},
				],
				lsZxxx: [{
						tit: "国家乡村振兴局赴红色教育基地参观学习国家乡村振兴局赴红色教育基地参观学习",
						id: 1,
					},
					{
						tit: "国家乡村振兴局召开学习贯彻习近平新时代中国特色近平新时代中国特色社...",
						id: 2,
					},
					{
						tit: "农业农村部（国家乡村振兴局）与西藏自治区政府召开...",
						id: 3
					},
					{
						tit: "贵南：党建助力村集体经济发展壮大",
						id: 4
					},
					{
						tit: "中共中央 国务院关于实施乡村振兴战略的意见",
						id: 5
					},
					{
						tit: "贵南：党建助力村集体经济发展壮大",
						id: 6
					},
					{
						tit: "中共中央 国务院关于实施乡村振兴战略的意见",
						id: 7
					},
				],
				zdxx: [{
						tit: "公布第三批城乡交通运输一体化示范创建县的通知",
						con: "根据《交通运输部关于组织开展第三批城乡交通运输一体化示范县创建工作的通知》（交运函〔2022〕663号），经有关县（市、区）申报、省级交通运输主管部门推荐...",
						time: "2023-07-07",
					},
					{
						tit: "交通运输部办公厅 中华全国总工会办公厅关于开展2023年“最美公交司...",
						con: "城市公共交通是为社会公众提供基本出行服务的社会公益性事业和重大民生工程。优先发展公共交通是缓解交通拥堵、转变城市交通发展方式、提升人民群众生活品质的必...",
						time: "2023-07-07",
					},
				],
				type1: [],
				type2: [],
				type3: [],
				type4: [],
				type5: [],
				type6: [],
				type7: [],
				type8: [], //顶部大图
				typeTotal: [],
			};
		},
		created() {
			this.id = this.$route.query.id;
			this.loadData();
		},
		methods: {
			loadData() {
				ztzlDetails({
					mh_ztzl_id: this.id,
				}).then((res) => {
					console.log(res);
					// this.bigImg = res.internal_img;
					const mergedData = res.data.reduce((result, item) => {
						const foundItem = result.find((obj) => obj.type === item.type);
						if (foundItem) {
							foundItem.child_list = foundItem.child_list.concat(item.child_list);
						} else {
							result.push(item);
						}
						return result;
					}, []);
					console.log(mergedData, 'vmergedData-----')
					mergedData.forEach((item) => {

						switch (item.type) {
							case "1":
								// this.type1.push(item);
								this.type1 = item.child_list;
								break;
							case "2":
								// this.type2.push(item);
								this.type2 = item.child_list;
								break;
							case "3":
								// this.type3.push(item);
								this.type3 = item.child_list;
								break;
							case "4":
								// this.type4.push(item);
								this.type4 = item.child_list;
								break;
							case "5":
								// this.type5.push(item);
								this.type5 = item.child_list;
								break;
							case "6":
								// this.type6.push(item);
								this.type6 = item.child_list;
								break;
							case "7":
								// this.type7.push(item);
								this.type7 = item.child_list;
								break;
							case "8":
								// this.type8.push(item);
								this.type8 = item.child_list;
								break;
						}
					});
				});
			},
			openPage(data) {
				console.log(data)
				if (data && data.openurl && data.openurl.length > 0) {
					window.open(data.openurl);
				}

			},
			handleBigImg(item) {
				console.log(item.openurl)
				if(!item.openurl) {
					window.open('/')
				}else {
					window.open(item.openurl)
				}
			}
		},
	};
</script>
<style lang="scss" scoped>
	.page {
		min-width: $minWidth;
	}

	.con {
		@include main;

		// type1
		.jy {
			background-color: #f5eee7;
			line-height: 36px;
			padding: 75px 40px 40px;

			span.p-a {
				line-height: 54px;
				background-color: #ca8c11;
				left: 17px;
				top: 0;
				max-width: 450px;
				font-family: "仓耳与墨";
			}

			p {
				text-indent: 40px;
			}
		}

		//type2
		.type2 {
			>p {
				line-height: 36px;
				text-indent: 40px;
			}
		}

		//type3
		.type3 {
			.list {
				dl {
					dd {
						width: calc(100% - 410px);
						p {
							line-height: 42px;
						}
					}
				}
			}
		}

		//4
		.type4 {
			.ul {
				li {
					width: 50%;
					float: left;
					line-height: 62px;

					span {
						position: relative;
						top: -3px;
						display: inline-block;
						width: 8px;
						height: 8px;
						background-color: $c481;
						border-radius: 8px;
					}
				}
			}
		}

		//5
		.type5 {
			.swiperBox {
				img {
					width: 700px;
					height: 370px;
				}

				.swiperTxt {
					background-color: #f3f3f3;

					p {
						line-height: 36px;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 6;
					}
				}
			}

			::v-deep .el-carousel {
				.el-carousel__container {
					height: 370px;
				}

				.el-carousel__indicators--horizontal {
					left: auto;
					right: 0px;
					bottom: 20px;

					.el-carousel__button {
						width: 12px;
						height: 12px;
						background-color: #c5d5e3;
						opacity: 1;
					}

					.is-active {
						.el-carousel__button {
							background-color: $c481;
						}
					}
				}
			}
		}

		.imgBox {
			padding-top: 38px;

			img {
				width: 100%;
			}

			span.p-a {
				right: 0;
				bottom: 7px;
			}
		}

		//6
		.type6 {
			.ul {
				li {
					width: 50%;
					float: left;
					line-height: 62px;

					span {
						position: relative;
						top: -3px;
						display: inline-block;
						width: 8px;
						height: 8px;
						background-color: $c481;
						border-radius: 8px;
					}
				}
			}
		}

		//7
		.type7 {
			.list {
				.item {
					h3 {
						&::after {
							position: absolute;
							left: 0;
							top: 5px;
							content: "";
							@include triangle(right, 11px, #004881);
						}
					}

					p {
						line-height: 42px;
					}
				}
			}
		}
	}

	@media (max-width: 768px) {
		.page {
			min-height: 2400px;
		}
	}
</style>
